import React, {
  Fragment,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useContext,
} from "react";
import { Button, Col, Form, Row, Tooltip } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useAppDispatch } from "../../../../store/hooks";
import {
  getDisposalAccount,
  getProductDetailByNdc,
  getReturnOrder,
  postReturnOrder,
  putReturnOrder,
  postNewNdc,
  checkCustomerLicence,
  getSalesOrdersWOProcessDateByCustomerId,
  getUpsGround
} from "../../../../store/api/apiSlice";
import NDCDetails from "./ndcDetails";
import NdcDetailsModal from "./ndcDetailsModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { toast } from "react-toastify";
import NewNdcSuccessModal from "./newNdcSuccessModal";
import DotInventoryModal from "./dotInventoryModal";
import { useSelector } from "react-redux";
import {
  DISABLED_STATES_FOR_SHIP,
  ENABLED_GROUND_STATES_FOR_SHIP,
  formateIds,
} from "../../../../interface/comman.constant";
import { StartReturnContext } from "../../../../context/StartReturnContext";
import PrePrintedLabelsModal from "./prePrintedLabels";
import PrePrintedLabelsSubmittedModal from "./prePrintedLabelsSubmitted";

const StartReturnHeader = forwardRef((props: any, ref: any) => {
  const minDate = new Date(1900, 0, 1); // Jan 1, 1900
  const maxDate = new Date(3025, 11, 31); // Dec 31, 3025
  const options_value: any = [
    { value: "1", label: "Start a Return - No CII's" },
    { value: "2", label: "Start a Return - Includes CII's" }

  ];
  const options_value1: any = [{ value: "3", label: "Inventory Only" },
  { value: "4", label: "Onsite Inventory Association" }];
  const refreshPage =
    useSelector((state: any) => state?.accounts?.refreshPage) || false;
  const status_id = { Draft: 1, Pending: 2 };

  const dispatch = useAppDispatch();
  const [disposalAccountData, setDisposalAccountData] = useState([]);
  const [entryMode, setEntryMode] = useState("");
  const [showNDCDetailsContainer, setshowNDCDetailsContainer] = useState(false);
  const [quantity, setQuantity] = useState(false);
  const [ndcValue, setNdcValue] = useState("");
  const [ndcPreviousValue, setNdcPreviousValue] = useState("");
  const [ndcDetailsData, setNdcDetailsData]: any = useState({});
  const [ndcError, setNdcError] = useState(false);
  const [ndcUnavailableError, setNdcUnavailableError] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null | undefined>(null);
  const [valid, setValid] = useState(true);
  const [bnsAccountId, setbnsAccountId] = useState("");
  const [shippingLabelQuantity, setShippingLabelQuantity] = useState("");
  const [tamperEvidentBagQuantity, setTamperEvidentBagQuantity] = useState("");
  const [gs1SerialNumber, setGs1SerialNumber] = useState("");
  const [lotNumber, setLotNumber] = useState("");
  const [quantityData, setQuantityData] = useState("");
  const [errorNDCMessage, setErrorNDCMessage] = useState("");
  const [errorOnsiteInventoryAssociationSOMessage, setErrorOnsiteInventoryAssociationSOMessage] = useState("");
  const [errorQuantityMessage, setErrorQuantityMessage] = useState("");
  const [errorBNSMessage, setErrorBNSMessage] = useState("");
  const [errorEntryModeMessage, setErrorEntryModeMessage] = useState("");
  const [responseData, setResponseData]: any = useState();
  const [bnsAccountName, setbnsAccountName] = useState("");
  const [accountState, setAccountState] = useState("");
  const [accountAddress, setAccountAddress] = useState("");
  const [accountCity, setAccountCity] = useState("");
  const [accountZip, setAccountZip] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountPhone, setAccountPhone] = useState("");
  const [upsNoGround, setUpsNoGround] = useState(false);
  const [upsRateResponse, setUpsRateResponse]: any = useState({});
  const [bnsSelectionError, setbnsSelectionError] = useState("");
  const [ndSuccessShow, setNdSuccessShow] = useState(false);
  const [dotInventoryShow, setDotInventoryShow] = useState(false);
  const [dotInventoryMessage, setDotInventoryMessage] = useState("");
  const [dotInventoryIcon, setDotInventoryIcon] = useState(0);
  const [errorShippingLable, setErrorShippingLable] = useState("");
  const [errorTamperBag, setErrorTamperBag] = useState("");
  const [DEALicence, setDEALicence]: any = useState();
  const [quantityGreaterMessage, setQuantityGreaterMessage] = useState("");
  const [errorLotMessage, setErrorLotMessage] = useState("");
  const [errorDateMessage, setErrorDateMessage] = useState<string>("");
  const [packageSize, setPackageSize] = useState("");
  const [isInventory, setIsInventory] = useState<any>();
  const [isCustomNDCMessage, setIsCustomNDCMessage] = useState(false);

  const [selectedRadio, setSelectedRadio] = useState("YES");
  const [supplyTypeRadio, setSupplyTypeRadio] = useState("BNS Kit");
  const [isAccountDisabled, setIsAccountDisabled] = useState(false);

  const disposal_options: any = [];

  const onsiteInventoryAssociationSO_options: any = [];
  const [onsiteInventoryAssociationSOID, setOnsiteInventoryAssociationSOID] = useState("");
  const [onsiteInventoryAssociationSOTranId, setOnsiteInventoryAssociationSOTranId] = useState("");
  const [factSalesOrders, setFactSalesOrders] = useState([]);

  const [isPrePrintedLabelsModal, setisPrePrintedLabelsModal] = useState(false);
  const handleShowPrintedLabelsModal = () => setisPrePrintedLabelsModal(true);
  const handleClosePrePrintedLabels = () => setisPrePrintedLabelsModal(false);
  const handlerePrintedLabelsError = (errorMessage: string) => {
    setErrorUsePreprintedLabels(errorMessage);
  };
  const [errorUsePreprintedLabels, setErrorUsePreprintedLabels] = useState("");
  const CustomNdcCaseAndPackageSize = "Unidentified Item";

  factSalesOrders &&
    factSalesOrders.map((item: any) =>
      onsiteInventoryAssociationSO_options.push({
        value: item.CONSOLIDATED_INTERNAL_ID,
        label: item.CONSOLIDATED_TRANID,
      })
    );



  const navigate = useNavigate();
  const location = useLocation();
  const userAccounts =
    useSelector((state: any) => state?.accounts?.chosenIds[0]) || [];
  let tmp = location.pathname.slice(
    location.pathname.lastIndexOf("/") + 1,
    location.pathname.length
  );

  const { supplyTypeSelected, updateStartRetrunContextData, printLabel, arsTracking, setArsTracking } =
    useContext(StartReturnContext);

  const isInputDisabled =
    printLabel || entryMode === "3" || tmp !== "start-Inventoried-return" || (entryMode === "1" && supplyTypeRadio === "Use Pre-printed labels") ||
    (entryMode === "1" && selectedRadio === "No Controls" && supplyTypeRadio === "BNS Kit");
  const [isPrePrintedLabelsSubmittedModal, setisPrePrintedLabelsSubmittedModal] = useState(false);
  const handleClosePrePrintedSubmittedLabels = () => setisPrePrintedLabelsSubmittedModal(false);
  const [orderid, setOrderId] = useState("");

  const onViewShippingLabel = () => {
    setOrderId(tmp);
    setisPrePrintedLabelsSubmittedModal(true);
  };

  const handleImportInventoryClick = () => {
    if (tmp === "start-Inventoried-return") {
      if (
        inventoryValidate()
      ) {
        try {
          const data: any = {
            //  Entry Mode
            // 1 - Basic
            // 2 - Advanced
            entryMode: Number(entryMode),
            bnsAccountId: bnsAccountId,
            bnsAccountName: bnsAccountName,
            customerState: accountState,
            shippingLabelQuantity: shippingLabelQuantity
              ? Number(shippingLabelQuantity)
              : null,
            tamperEvidentBagQuantity: tamperEvidentBagQuantity
              ? Number(tamperEvidentBagQuantity)
              : null,
            products: [],
            //status id
            //Draft = 1,
            // Pending = 2
            statusId: status_id.Draft,
            salesorderid: onsiteInventoryAssociationSOID === "" ? null : Number(onsiteInventoryAssociationSOID),
            ordernumber: onsiteInventoryAssociationSOTranId,
            supplytype: supplyTypeRadio,
            bagoption: selectedRadio,

          };

          if (supplyTypeRadio === "Use Pre-printed labels") {
            data.prePrintedLabels = arsTracking.map(item => ({
              ArsTrackingId: item.ID,
              ArsTracking: item.CUSTRECORD_ARS_TRACKING_NUMBER,
            }));
          }

          //post
          dispatch(postReturnOrder(data)).then((result: any) => {
            setNdcPreviousValue("");
            if (result.payload.data) {
              navigate(
                "/services/start-Inventoried-return/" + result.payload.data.id
              );
              props.handleShow(result.payload.data.id);
            }
          });
        } catch (error) { }
      }
    } else {
      props.handleShow(tmp);
    }
  };
  useImperativeHandle(ref, () => ({
    handleImportInventoryClick, onViewShippingLabel, setResponseData
  }));

  const inventoryValidate = () => {
    let isValid = true;

    if (!entryMode) {
      setErrorEntryModeMessage("Entry Mode is required");
      isValid = false;
    }

    if (!bnsAccountId) {
      setErrorBNSMessage("Account is required");
      isValid = false;
    }

    if (entryMode === "4" && onsiteInventoryAssociationSOID === "") {
      setErrorOnsiteInventoryAssociationSOMessage("Sales Order is required");
      isValid = false;
    }

    var validateShippingLabelQuantity = true;
    if (supplyTypeRadio === "Print Labels")
      validateShippingLabelQuantity = false;
    if (entryMode === "3")
      validateShippingLabelQuantity = false;
    if (entryMode === "1" && supplyTypeRadio === "Use Pre-printed labels")
      validateShippingLabelQuantity = false;
    if (entryMode === "4")
      validateShippingLabelQuantity = false;
    if (selectedRadio === "No Controls" && supplyTypeRadio === "BNS Kit")
      validateShippingLabelQuantity = false;

    if (validateShippingLabelQuantity) {
      if (shippingLabelQuantity === "" || Number(shippingLabelQuantity) === 0) {
        setErrorShippingLable(
          "Quantity of Shipping Labels should be minimum 1."
        );
        isValid = false;
      }

      if (tamperEvidentBagQuantity === "" || Number(tamperEvidentBagQuantity) === 0) {
        setErrorTamperBag(
          "Quantity of Tamper Evident bags should be minimum 1."
        );
        isValid = false;
      }
    }

    setErrorUsePreprintedLabels("");
    if (entryMode === "1" && tmp === "start-Inventoried-return") {
      if (supplyTypeRadio === "Use Pre-printed labels") {
        if ((!arsTracking || arsTracking.length === 0)) {
          setErrorUsePreprintedLabels("No labels selected");
          isValid = false;
        }
      }
    }

    return isValid;
  };

  disposalAccountData &&
    disposalAccountData.map((item: any) =>
      disposal_options.push({
        value: item.id,
        label: item.customerCode + "-" + item.disposalAccountName,
        isInventoryOnly: item.isInventoryOnly,
        stateAbbreviation: item.shippinG_STATE_ABBREVIATION,
        customerState: item.cusT_STATE,
        customerAddress: item.shippinG_ADDRESS,
        customerCity: item.shippinG_CITY,
        customerZip: item.shippinG_ZIP,
        customerName: item.shippinG_ADDRESSEE,
        customerPhone: item.phone
      })
    );

  const onsiteInventoryAssociationSOChange = (e: any) => {
    if (!e) {
      setOnsiteInventoryAssociationSOID("");
      setOnsiteInventoryAssociationSOTranId("");
      setErrorOnsiteInventoryAssociationSOMessage("");
      return;
    }
    const newValue = e.value;
    if (newValue === onsiteInventoryAssociationSOID) return;
    setOnsiteInventoryAssociationSOID(newValue);
    setOnsiteInventoryAssociationSOTranId(e.label);
    setErrorOnsiteInventoryAssociationSOMessage("");
  };

  const entryModeChange = (e: any) => {
    let upsNoGroundTemp = upsNoGround;
    setUpsNoGround(false);
    props.updateIsDisabledImport(false);
    const newValue = e.value;
    if (upsNoGroundTemp === true && newValue === entryMode) {
      setUpsNoGround(true);
      props.updateIsDisabledImport(true);
    }
    if (newValue === entryMode) return;
    setEntryMode(e.value);
    setErrorEntryModeMessage("");
    setSelectedRadio("");
    setSupplyTypeRadio("");
    updateStartRetrunContextData("");
    setOnsiteInventoryAssociationSOID("");
    setOnsiteInventoryAssociationSOTranId("");
    setErrorUsePreprintedLabels("");
    setArsTracking([]);
    setErrorLotMessage("");
    
    if (e.value === "1") {
      setSelectedRadio("YES");
      setSupplyTypeRadio("BNS Kit");
      updateStartRetrunContextData("BNS Kit");
    }

    if (e.value === "2" && errorNDCMessage !== "") {
      setErrorNDCMessage("");
    }
    if (
      (e.value === "3" || supplyTypeRadio === "Print Labels") &&
      errorShippingLable !== "" &&
      errorTamperBag !== ""
    ) {
      setErrorShippingLable("");
      setErrorTamperBag("");
    }

    if (e.value === "4") {

      dispatch(getSalesOrdersWOProcessDateByCustomerId(bnsAccountId)).then((result: any) => {
        setFactSalesOrders(result?.payload?.data);
      })
    }
  };
  const getDropDownData = () => {
    try {
      let data = 1;
      dispatch(
        getDisposalAccount({
          data: data,
          customerIds: formateIds(userAccounts),
        })
      ).then((result: any) => {
        setDisposalAccountData(result?.payload?.data);
      });
    } catch (error) { }
  };

  useEffect(() => {
    getDropDownData();
    getGridData(tmp);
  }, [refreshPage]);

  useEffect(() => {
    if (!ndcError) {
      const paddedNDC = ndcPreviousValue;
      setNdcValue(paddedNDC);
    }
  }, [ndcError]);



  const bnsAccountChange = (e: any) => {
    setbnsSelectionError("");
    setErrorBNSMessage("");
    setbnsAccountName(e.label);
    setbnsAccountId(e.value);
    setIsInventory(e.isInventoryOnly);
    setEntryMode("");
    setErrorEntryModeMessage("Entry Mode is required");
    setOnsiteInventoryAssociationSOID("");
    setOnsiteInventoryAssociationSOTranId("");
    setErrorUsePreprintedLabels("");
    setArsTracking([]);
    setErrorLotMessage("");
    setUpsNoGround(false);
    props.updateIsDisabledImport(false);
    setUpsRateResponse({});
    setAccountState(e.customerState);
    setAccountAddress(e.customerAddress);
    setAccountCity(e.customerCity);
    setAccountZip(e.customerZip);
    setAccountName(e.customerName);
    setAccountPhone(e.customerPhone);

    if (
      e?.stateAbbreviation &&
      DISABLED_STATES_FOR_SHIP.includes(e.stateAbbreviation)
    ) {
      setIsAccountDisabled(true);
    } else if (isAccountDisabled) {
      setIsAccountDisabled(false);
    }

    //API call for Return Order Access
    try {
      dispatch(checkCustomerLicence(e.value)).then((result: any) => {
        if (result?.payload?.data?.returnOrderAccess === false) {
          setErrorBNSMessage(
            "Start a Return Order is not accessible for the selected BNS Account"
          );
          setDEALicence(false);
          props.DEALicence(false);
        } else {
          setDEALicence(true);
          props.DEALicence(true);
        }

        // check if the selected account state (not null) is not in ENABLED_GROUND_STATES_FOR_SHIP and "Box and Ship"
        // show dot inventory popup message
        if (e.stateAbbreviation !== null && !ENABLED_GROUND_STATES_FOR_SHIP.includes(e.stateAbbreviation) && e.isInventoryOnly === false) {
          setDotInventoryIcon(1);
          setDotInventoryMessage("Please ensure that no dangerous goods are included which do not adhere to DOT and international transportation regulation.");
          setDotInventoryShow(true);
        }

      });
    } catch (error) { }

  };

  const switchChange = (e: any) => {
    // reset error message 
    setErrorQuantityMessage("");
    setQuantity(e.target.checked);
    if (Number(quantityData) === 0) {
      setNdcDetailsDataQuantityValidation("", e.target.checked);
    } else {
      setNdcDetailsDataQuantityValidation(quantityData, e.target.checked);
    }
  };

  const onKeyUpHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.currentTarget.value.length === 0) {
      setshowNDCDetailsContainer(false);
    }
  };

  const onKeyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget.value;

    setErrorNDCMessage("");
    setNdcError(false);
    setNdcUnavailableError(false);

    if (bnsAccountId === "") {
      setErrorBNSMessage("BNS Account is required");
      return;
    }

    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
      return;
    }

    const tmpNdcValue: any = ["e", "E", ".", "+", "-"];
    if (tmpNdcValue.includes(e.key)) {
      setErrorNDCMessage("NDC number should be digit only");
      e.preventDefault()
      return;
    }
   
    //validate padded
    if (e.key === "Enter" || e.key === "Tab") {
      const paddedNDC = inputValue.length > 0 ? inputValue.padStart(10, '0') : "";
      if (paddedNDC.length > 0) { 

        if (!isAllZeros(paddedNDC))      
          getNDCDetails();        

      }
    }
  };

  const onNDCPaste = () => {
    setErrorNDCMessage("");
  };

  const NdcValueBlur = (e: any) => {

    if (bnsAccountId === "") {
      setErrorBNSMessage("BNS Account is required");
      return;
    }

    
    const inputValue = e.currentTarget.value;
    const paddedNDC = inputValue.length > 0 ? inputValue.padStart(10, '0') : "";
    if (paddedNDC.length > 0) {
      if (!isAllZeros(paddedNDC))
        getNDCDetails();



    }
  };
  const handleClose = (data: any) => {
    // reset data in modal
    if(data && (data.ndc || data.product || data.deaClass)) {
      data.ndc = "";
      data.product = "";
      data.deaClass = null;
    }
    setbnsSelectionError("");
    setShow(false);
    resetData();
  }
  const ndcSucessClose = () => {
    setNdSuccessShow(false);
    resetData();
  }
  const dotInventoryClose = () => {
    setDotInventoryShow(false);
  }

  const handleSave = (e: any, data: any) => {
    e.preventDefault();
    setIsCustomNDCMessage(false);

    if (!/^\d{11}$/.test(data.ndc) || data.ndc === "00000000000") {
      setbnsSelectionError("NDC number is invalid");
    } else if (data.product === "" || /[<>\/\\{}();"'`]/.test(data.product)) {
      setbnsSelectionError("NDC product is invalid");
    } else if (!["0", "2", "3", "4", "5"].includes(data.deaClass)) {
      setbnsSelectionError("DEA Class value must be one of the following: 0, 2, 3, 4, or 5");
    } else {
      if (bnsAccountId && bnsAccountName) {
        //API call
        data.bnsAccountId = bnsAccountId;
        data.bnsAccountName = bnsAccountName;
        data.deaClass = Number(data.deaClass);
        data.returnOrderId = (tmp === "start-Inventoried-return" ? "00000000-0000-0000-0000-000000000000" : tmp);

        dispatch(postNewNdc(data)).then((result: any) => {
          if (result.payload.isSuccess) {
            // show extra message when entryMode is not 2 (Start a Return - Includes CII's), 4 (Onsite Inventory Association) and custom NDC is not CII
            if (entryMode !== "2" && entryMode !== "4" && Number(data.deaClass) !== 2) {
              setIsCustomNDCMessage(true);
            }
            // reset data
            data.ndc = "";
            data.product = "";
            data.deaClass = null;
            //show popup
            setNdSuccessShow(true);
            setShow(false);
          } else {
            setbnsSelectionError("The NDC you entered already exists. To add a new product, please use a unique NDC");
          }
        });
      } else {
        setbnsSelectionError("Select BNS Account to save ndc details");
      }
    }
  };

  const handleDateChange = (e: any) => {
    setSelectedDate(e);
    document?.getElementById("gs1serial")?.focus();
  };

  const isAllZeros = (str: string): boolean => str !== '' && /^0+$/.test(str);

  const validate = () => {
    let result = true;
    if (ndcValue === "") {
      setErrorNDCMessage("NDC is required");
      result = false;
    } else if (ndcValue !== "" && ndcError === false) {
      const paddedNDC = ndcValue.padStart(10, '0');
      if (paddedNDC.length > 11) {
        setErrorNDCMessage("NDC number should be of 10 or 11 digit");
        result = false;
      }
      else if (isAllZeros(paddedNDC)){
         setErrorNDCMessage("NDC number should be of 10 or 11 digit");
        result = false;
      }
      else if (Object?.keys(ndcDetailsData).length === 0) {
        setErrorNDCMessage(
          "NDC details should not be empty. Press enter to get NDC details."
        );
        result = false;
      }
    }
    if (entryMode === "") {
      setErrorEntryModeMessage("Entry Mode is required");
      result = false;
    }
    if (bnsAccountId === "") {
      setErrorBNSMessage("BNS Account is required");
      result = false;
    }

    if (quantityData === "" || isNaN(Number(quantityData))) {
      setErrorQuantityMessage("Quantity is required");
      result = false;
    }
    // Full
    else if (quantity === false && !Number.isInteger(Number(quantityData))) {
      setErrorQuantityMessage("Quantity must be a whole number");
      result = false;
    } else if (quantity === false && Number(quantityData) < 1) {
      setErrorQuantityMessage("Quantity must be greater than 0");
      result = false;
    } else if (quantity === false && Number(quantityData) > 9999) {
      setErrorQuantityMessage("Quantity allows maximum 4 digit");
      result = false;
    }
    // Partial
    else if (quantity === true && Number(quantityData) < 0.01) {
      setErrorQuantityMessage("Quantity must be greater than 0");
      result = false;
    } else if (
      quantity === true &&
      ndcDetailsData?.casePack > 1 &&
      !Number.isInteger(Number(quantityData))
    ) {
      // Do not permit decimals for partials when the case pack is greater than 1
      setErrorQuantityMessage("Quantity must be a whole number");
      result = false;
    } else if (
      quantity === true &&
      ndcDetailsData?.casePack > 1 &&
      parseFloat(quantityData) > ndcDetailsData?.casePack
    ) {
      setErrorQuantityMessage(
        "Partial Quantity cannot be greater than case pack"
      );
      result = false;
    } else if (
      quantity === true &&
      ndcDetailsData?.casePack === 1 &&
      parseFloat(quantityData) > ndcDetailsData?.packageSize
    ) {
      setErrorQuantityMessage(
        "Partial Quantity cannot be greater than package size"
      );
      result = false;
    }

    setErrorUsePreprintedLabels("");
    if (entryMode === "1" && tmp === "start-Inventoried-return") {
      if (supplyTypeRadio === "Use Pre-printed labels") {
        if ((!arsTracking || arsTracking.length === 0)) {
          setErrorUsePreprintedLabels("No labels selected");
          result = false;
        }
      }
    }

    setErrorLotMessage("");
    setErrorDateMessage("");

    if (selectedDate) {
      const date = moment(selectedDate, "MM/YYYY", true);
      if (!date.isValid()) {
        setErrorDateMessage("Expiration date must be in MM/YYYY format");
        result = false;
      } else if (date.year() < 1900 || date.year() > 3025) {
        setErrorDateMessage("Expiration year must be valid");
        result = false;
      }
    }


    var validateShippingLabelQuantity = true;
    if (([1, 2].includes(Number(entryMode))) && (supplyTypeRadio === "Print Labels"))
      validateShippingLabelQuantity = false;
    if (entryMode === "1" && supplyTypeRadio === "Use Pre-printed labels")
      validateShippingLabelQuantity = false;
    if (entryMode === "3")
      validateShippingLabelQuantity = false;
    if (entryMode === "4")
      validateShippingLabelQuantity = false;
    if (selectedRadio === "No Controls" && supplyTypeRadio === "BNS Kit")
      validateShippingLabelQuantity = false;

    if (validateShippingLabelQuantity) {
      if (shippingLabelQuantity === "" || Number(shippingLabelQuantity) === 0) {
        setErrorShippingLable(
          "Quantity of Shipping Labels should be minimum 1."
        );
        result = false;
      }
      if (tamperEvidentBagQuantity === "" || Number(tamperEvidentBagQuantity) === 0) {
        setErrorTamperBag(
          "Quantity of Tamper Evident bags should be minimum 1."
        );
        result = false;
      }
    }

    if (entryMode === "4") {
      if ([2, 3, 4, 5].includes(Number(ndcDetailsData.deaClass))) {
        setErrorNDCMessage("Controls can only be inventoried by a Pharma Logistics Rep OnSite");
        result = false;
      }

      if (onsiteInventoryAssociationSOID === "") {
        setErrorOnsiteInventoryAssociationSOMessage("Sales Order is required");
        result = false;
      }
    }

    return result;
  };

  const setNdcDetailsDataQuantityValidation = (
    newfullqty: any,
    fullorpartial: any
  ) => {
    setQuantityData(newfullqty);

    let newValidStr = "";

    // 2 decimal
    let newqty = parseFloat(newfullqty).toFixed(4).toString();
    newqty = newqty.substring(0, newqty.length - 2);
    newqty = Number(newqty).toString();
    if (
      !newfullqty.endsWith(".0") &&
      !newfullqty.endsWith(".00") &&
      !isNaN(Number(newqty))
    ) {
      setQuantityData(newqty);
    }

    //partial
    if (fullorpartial && newfullqty) {
      if (ndcDetailsData?.casePack > 1)
        newValidStr =
          newfullqty === ""
            ? ""
            : newqty + " " + ndcDetailsData?.packageDescription;
      else
        newValidStr =
          newfullqty === ""
            ? ""
            : newqty + " " + ndcDetailsData?.dosageForm;
    }
    //full
    if (!fullorpartial && newfullqty) {
      newValidStr =
        parseInt(newqty) * ndcDetailsData?.casePack +
        " " +
        ndcDetailsData?.packageDescription;
    }

    const currentv = ndcDetailsData;
    setNdcDetailsData({ ...currentv, quantityValidation: newValidStr });
  };

  const addButtonClick = (e: any) => {
    e.preventDefault();
    let result = validate();
    if (result === false) {
      return;
    }
    const paddedNDC = ndcValue.padStart(10, '0');
    if (
      quantityData === "" ||
      quantityData === null ||
      (quantity === false && Number(quantityData) < 1) ||
      (quantity === true && Number(quantityData) < 0.01) ||
      ndcValue === null ||
      ndcValue === "" ||
      (paddedNDC || "").length < 10 ||
      (paddedNDC || "").length > 11 ||
      Object.keys(ndcDetailsData || {}).length === 0
    ) {
      return;
    }
    if (entryMode === "2" || entryMode === "4") {
      if (ndcDetailsData.caseAndPackageSize === CustomNdcCaseAndPackageSize) {
        setErrorNDCMessage("Custom NDC not allowed for selected entry mode");
        return;
      }
    }
    if (entryMode === "1" && ndcDetailsData.deaClass === 2) {
      setErrorNDCMessage("DEA Class 2 NDC not allowed for selected entry mode");
      return;
    }
    if (
      errorNDCMessage === "" &&
      errorQuantityMessage === "" &&
      errorBNSMessage === "" &&
      errorEntryModeMessage === "" &&
      errorShippingLable === "" &&
      errorTamperBag === "" &&
      ndcError === false &&
      ndcUnavailableError === false
    ) {

      let expirationDate = selectedDate
        ? `${String(selectedDate.getMonth() + 1).padStart(2, "0")}/${selectedDate.getFullYear()}`
        : "";

      if (tmp !== "start-Inventoried-return") {
        try {
          const data = responseData;
          const newProduct = {
            ndc: ndcDetailsData?.ndc?.toString(),
            quantityType: quantity === false ? 2 : 1,
            quantity: Number(quantityData),
            lotNumber: lotNumber,
            expirationDate: expirationDate,
            gs1SerialNumber: gs1SerialNumber,
            productName: ndcDetailsData?.product,
            deaClass: ndcDetailsData?.deaClass,
            caseAndPackageSize: ndcDetailsData?.caseAndPackageSize,
            quantityValidation: ndcDetailsData?.quantityValidation,
            isInnerNdc: ndcDetailsData?.isInnerNdc,

            isNew: true,
            stateDeaClass: ndcDetailsData?.stateDeaClass,
          };
          data?.products.push(newProduct);
          data["statusId"] = status_id.Draft;

          if (supplyTypeRadio === "Use Pre-printed labels") {
            data.prePrintedLabels = arsTracking.map(item => ({
              ArsTrackingId: item.ID,
              ArsTracking: item.CUSTRECORD_ARS_TRACKING_NUMBER,
            }));
          }

          data.returnOrderId = tmp;
          // put;
          data.products.forEach((element: any) => {
            if (element["quantity"] === "") {
              element["quantity"] = element["quantity1"];
              delete element["quantity1"];
            }
            if (
              element["isNew"] &&
              ndcDetailsData?.casePack > 1 &&
              newProduct["quantityType"] === 1 &&
              ndcDetailsData?.casePack === newProduct["quantity"]
            ) {
              element["quantity"] = 1;
              element["quantityType"] = 2;
              delete element["isNew"];
            } else if (
              element["isNew"] &&
              ndcDetailsData?.casePack === 1 &&
              newProduct["quantityType"] === 1 &&
              ndcDetailsData?.packageSize === newProduct["quantity"]
            ) {
              element["quantity"] = 1;
              element["quantityType"] = 2;
              delete element["isNew"];
            }
          });
          dispatch(putReturnOrder(data)).then((result: any) => {
            setNdcPreviousValue("");
            if (result?.payload?.isSuccess) {
              toast.success("Saved Successfully");
              getGridData(responseData.id);
              resetData();
            }
          });
        } catch (error) { }
      } else {
        try {
          const data = {
            //  Entry Mode
            // 1 - Basic
            // 2 - Advanced
            entryMode: Number(entryMode),
            bnsAccountId: bnsAccountId,
            bnsAccountName: bnsAccountName,
            shippingLabelQuantity: shippingLabelQuantity
              ? Number(shippingLabelQuantity)
              : null,
            tamperEvidentBagQuantity: tamperEvidentBagQuantity
              ? Number(tamperEvidentBagQuantity)
              : null,
            customerState: accountState,
            products: [
              {
                ndc: ndcDetailsData?.ndc?.toString(),
                //QuantityType
                // 1 - Partial
                // 2 - Full
                quantityType: quantity === false ? 2 : 1,
                quantity: Number(quantityData),
                lotNumber: lotNumber,
                expirationDate: expirationDate,
                gs1SerialNumber: gs1SerialNumber,
                productName: ndcDetailsData?.product,
                deaClass: ndcDetailsData?.deaClass,
                caseAndPackageSize: ndcDetailsData?.caseAndPackageSize,
                quantityValidation: ndcDetailsData?.quantityValidation,
                isInnerNdc: ndcDetailsData?.isInnerNdc,
                stateDeaClass: ndcDetailsData?.stateDeaClass,
              },
            ],
            //status id
            //Draft = 1,
            // Pending = 2
            statusId: status_id.Draft,
            supplytype: supplyTypeRadio,
            bagoption: selectedRadio,
            salesorderid: onsiteInventoryAssociationSOID === "" ? null : Number(onsiteInventoryAssociationSOID),
            ordernumber: onsiteInventoryAssociationSOTranId,
            prePrintedLabels: arsTracking.map(item => ({
              ArsTrackingId: item.ID,
              ArsTracking: item.CUSTRECORD_ARS_TRACKING_NUMBER,
            }))
          };

          if (
            ndcDetailsData?.casePack > 1 &&
            data.products[0]["quantityType"] === 1 &&
            ndcDetailsData?.casePack === data.products[0]["quantity"]
          ) {
            data.products[0]["quantity"] = 1;
            data.products[0]["quantityType"] = 2;
          } else if (
            ndcDetailsData?.casePack === 1 &&
            data.products[0]["quantityType"] === 1 &&
            ndcDetailsData?.packageSize === data.products[0]["quantity"]
          ) {
            data.products[0]["quantity"] = 1;
            data.products[0]["quantityType"] = 2;
          }
          //post
          dispatch(postReturnOrder(data)).then((result: any) => {
            setNdcPreviousValue("");
            if (result?.payload?.data) {
              toast.success("Saved Successfully");
              navigate(
                "/services/start-Inventoried-return/" + result.payload.data.id
              );
              getGridData(result.payload.data.id);
              setQuantityData("");
              setLotNumber("");
              setSelectedDate(undefined);
              setQuantity(false);
              setGs1SerialNumber("");
              setNdcValue("");
              document?.getElementById("ndc")?.focus();
            }
          });
        } catch (error) { }
      }
    }
  };
  const resetData = () => {
    setNdcDetailsData("");
    setNdcError(false);
    setNdcUnavailableError(false);
    setNdcPreviousValue("");
    setNdcValue("");
    setQuantityData("");
    setQuantity(false);
    setLotNumber("");
    setSelectedDate(undefined);
    setGs1SerialNumber("");
    setUpsNoGround(false);
    props.updateIsDisabledImport(false);
    setUpsRateResponse({});
    setIsCustomNDCMessage(false);
    document?.getElementById("ndc")?.focus();
  };

  const getGridData = (id: any) => {
    if (id !== "start-Inventoried-return") {
      try {
        dispatch(getReturnOrder(id)).then((result: any) => {
          props.gridDataResult(result?.payload?.data);
          setResponseData(result?.payload?.data);
          setShippingLabelQuantity(result?.payload?.data.shippingLabelQuantity);
          setTamperEvidentBagQuantity(
            result?.payload?.data.tamperEvidentBagQuantity
          );
          setbnsAccountId(result?.payload?.data.bnsAccountId);
          setbnsAccountName(result?.payload?.data.bnsAccountName);
          setAccountState(result?.payload?.data.customerState);
          setEntryMode(result?.payload?.data.entryMode.toString());
          if ([3, 4].includes(Number(result?.payload?.data.entryMode))) setIsInventory(true);
          setDEALicence(true);
          props.DEALicence(true);
          setNdcDetailsData({});
          setSupplyTypeRadio(result?.payload?.data.supplyType);
          updateStartRetrunContextData(result?.payload?.data?.supplyType || "");
          setSelectedRadio(result?.payload?.data.bagOption);
          if (result?.payload?.data.entryMode === 4) {
            setOnsiteInventoryAssociationSOID(result?.payload?.data.salesOrderId);
            setOnsiteInventoryAssociationSOTranId(result?.payload?.data.orderNumber);
          }
        });
      } catch (error) { }
    }
  };

  const cleanAddressString = (str: string) => {
    if (!str) return str;
    return str.replace(/['"]/g, "").trim();
  };

  const getUpsRate = () => {
    try {
      setUpsNoGround(false);
      props.updateIsDisabledImport(false);
      // show dot inventory popup message for AK and HI states
      if (accountState === null) {
        setUpsNoGround(true);
        props.updateIsDisabledImport(true);
        toast.error("No default shipping address is associated to your account. Please contact customer service to set up your shipping address.");
      } else if (accountState === "AK" || accountState === "HI") {
        // if upsRateResponse is not available retrieve from api
        if (!upsRateResponse || (upsRateResponse.State !== accountState || upsRateResponse.PostalCode !== accountZip)) {
          setUpsRateResponse({});
          let data = {
            CustomerId: bnsAccountId,
            CustomerName: cleanAddressString(accountName),
            CustomerCompanyName: cleanAddressString(accountName),
            PhoneNumber: accountPhone,
            Address1: cleanAddressString(accountAddress) || "empty",
            City: accountCity || "empty",
            State: accountState || "empty",
            PostalCode: accountZip || "empty",
            NumberOfLabel: 0,
            PickupDate: new Date()
          };
          dispatch(getUpsGround(data)).then((result: any) => {
            if (result?.payload?.response) {
              setUpsRateResponse({
                CustomerId: bnsAccountId,
                State: accountState,
                PostalCode: accountZip,
                Code: result?.payload?.response?.code,
                IsGroundAvailable: result?.payload?.isGroundAvailable
              });
              if (result?.payload?.response?.code === "0" || result?.payload?.isGroundAvailable === false) {
                setUpsNoGround(true);
                props.updateIsDisabledImport(true);
                setDotInventoryIcon(0);
                setDotInventoryMessage("UPS does not currently provide ground shipping from your area. Please contact customer service to arrange alternative transportation.");
                setDotInventoryShow(true);
              }
            } else {
              toast.error("Error retrieving shipping information.");
            }
          });
        } else {
          // show dot inventory popup message based on upsRateResponse
          if(upsRateResponse && upsRateResponse.State === accountState && upsRateResponse.PostalCode === accountZip) {
            if (upsRateResponse.Code === "0" || upsRateResponse.IsGroundAvailable === false) {
              setUpsNoGround(true);
              props.updateIsDisabledImport(true);
              setDotInventoryIcon(0);
              setDotInventoryMessage("UPS does not currently provide ground shipping from your area. Please contact customer service to arrange alternative transportation.");
              setDotInventoryShow(true);
            }
          }
        }
      }
    } catch (error) { }
  };
  
  const getNDCDetails = () => {
    try {
      if (ndcValue) {
        const paddedNDC = ndcValue.padStart(10, '0');
        let data = { ndc: paddedNDC,
          customerState: accountState,
          returnOrderId: (tmp === "start-Inventoried-return" ? "00000000-0000-0000-0000-000000000000" : tmp)
         };
        dispatch(getProductDetailByNdc(data)).then((result: any) => {
          setNdcPreviousValue(ndcValue);
          if (result?.payload?.data) {
            setNdcError(false);
            setErrorNDCMessage("");
            setNdcDetailsData(result?.payload?.data);
            setNdcPreviousValue(paddedNDC);
            setNdcValue(paddedNDC);
            setshowNDCDetailsContainer(true);
            setPackageSize(
              result?.payload?.data?.packageSize &&
                result?.payload?.data?.packageSize > 0
                ? result?.payload?.data?.packageSize
                : 0
            );

            //Account and entry mode must be selected
            if (bnsAccountId === "") {
              setErrorBNSMessage("BNS Account is required");
            }
            if (bnsAccountId != "" && entryMode === "") {
              setErrorEntryModeMessage("Entry Mode is required");
            }

            //API call for DEA class
            if (
              result.payload.data.deaClass === 2 ||
              result.payload.data.deaClass === 3 ||
             result.payload.data.deaClass === 4 ||
              result.payload.data.deaClass === 5
            ) {
              try {

                if (bnsAccountId === "") {
                  setErrorBNSMessage("BNS Account is required");
                }
                else {
                  dispatch(checkCustomerLicence(bnsAccountId)).then(
                    (result: any) => {
                      if (result?.payload?.data?.isDeaLicense === false) {
                        setErrorNDCMessage(
                          "The DEA license is expired for the selected account"
                        );
                        setDEALicence(result?.payload?.data?.isDeaLicense);
                        props.DEALicence(result?.payload?.data?.isDeaLicense);
                      } else {
                        setDEALicence(result?.payload?.data?.isDeaLicense);
                        props.DEALicence(result?.payload?.data?.isDeaLicense);
                      }
                    }
                  );
                }
              } catch (error) { }
            } else {
              setDEALicence(true);
              props.DEALicence(true);
            }
          } else {
            if (ndcValue.length > 11) {
              setErrorNDCMessage("NDC number length should not be greater than 11");
              setNdcError(true);
              return;
            }
            else if (ndcValue.length < 10) {
              setErrorNDCMessage("NDC number should be of 10 or 11 digit");
              setNdcError(true);
            }
            else {
              setNdcUnavailableError(true);
              setshowNDCDetailsContainer(false);
            }
          }
        });
      }
    } catch (error) { }
  };
  const handleChangeRaw = (value: any) => {
    setErrorDateMessage(""); 

    // Match MM/YYYY format using regex
    const regex = /^(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(value)) {
      setErrorDateMessage("Invalid format. Use MM/YYYY.");
      setSelectedDate(null);
      return;
    }

    const [monthStr, yearStr] = value.split("/");
    const month = parseInt(monthStr, 10) - 1; // JS months are 0-indexed
    const year = parseInt(yearStr, 10);
    const parsedDate = new Date(year, month, 1);
    setSelectedDate(parsedDate);
    if (parsedDate < minDate || parsedDate > maxDate) {
      setErrorDateMessage("Date must be between 01/1900 and 12/3025.");
    } else {
      setErrorDateMessage("");
    }
  };

  const radioChange = (e: any, name: any) => {
    let upsNoGroundTemp = upsNoGround;
    setErrorUsePreprintedLabels("");
    setUpsNoGround(false);
    props.updateIsDisabledImport(false);
    setSelectedRadio(name);
    if (name === "NO") {
      setSupplyTypeRadio("BNS Kit");
      updateStartRetrunContextData("BNS Kit");
      setArsTracking([]);
    }
    
    if (upsNoGroundTemp === true && (name === "YES" || name === "No Controls")) {
      setUpsNoGround(true);
      props.updateIsDisabledImport(true);
    }
  };

  const radioChangeSupplyType = (e: any, name: any) => {
    setSupplyTypeRadio(name);
    updateStartRetrunContextData(name);
    setUpsNoGround(false);
    props.updateIsDisabledImport(false);

    if (name === "BNS Kit") {
      setArsTracking([]);
    }

    if (name === "Print Labels") {
      setShippingLabelQuantity("");
      setErrorShippingLable("");
      setTamperEvidentBagQuantity("");
      setErrorTamperBag("");
      setArsTracking([]);
      getUpsRate();
    }

    setErrorUsePreprintedLabels("");
    if (name === "Use Pre-printed labels") {
      handleShowPrintedLabelsModal();
      setShippingLabelQuantity("");
      setErrorShippingLable("");
      setTamperEvidentBagQuantity("");
      setErrorTamperBag("");
    }
  };

  return (
    <>
      <div className="top-controls">
        <Form className="form_box">
          <Row className={`gx-3`}>
            <Col lg={6} xs={12}>
              <Row className={`gx-3 two `}>
                <Col xs={12} md={6} xl={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Account <i className="fa fa-asterisk  error-estric"></i>
                    </Form.Label>
                    {disposal_options && (
                      <Select
                        required
                        options={disposal_options}
                        onChange={(e) => bnsAccountChange(e)}
                        isDisabled={
                          tmp !== "start-Inventoried-return" ? true : false
                        }
                        value={
                          bnsAccountId
                            ? {
                              value: bnsAccountId,
                              label: bnsAccountName,
                            }
                            : {}
                        }
                      />
                    )}
                    {errorBNSMessage && (
                      <p className="error-validation">{errorBNSMessage}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col xs={12} md={6} xl={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Entry Mode{" "}
                      <i className="fa fa-asterisk  error-estric"></i>
                    </Form.Label>
                    {isInventory === true
                      ? options_value1 && (
                        <Select
                          options={options_value1}
                          onChange={(e) => {
                            entryModeChange(e);
                          }}
                          isDisabled={
                            !bnsAccountName
                              ? true
                              : tmp !== "start-Inventoried-return"
                                ? true
                                : false
                          }
                          value={entryMode
                            ? entryMode === "3"
                              ? options_value1[0] : entryMode === "4"
                                ? options_value1[1]
                                : {}
                            : {}}
                        />
                      )
                      : options_value && (
                        <Select
                          options={options_value}
                          onChange={(e) => {
                            entryModeChange(e);
                          }}
                          isDisabled={
                            !bnsAccountName
                              ? true
                              : tmp !== "start-Inventoried-return"
                                ? true
                                : false
                          }
                          value={
                            entryMode
                              ? entryMode === "1"
                                ? options_value[0]
                                : entryMode === "2"
                                  ? options_value[1]
                                  : {}
                              : {}
                          }
                        />
                      )}

                    {errorEntryModeMessage && (
                      <p className="error-validation">
                        {errorEntryModeMessage}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            {entryMode === "1" && !isAccountDisabled && (
              <>
                <Col xs={6} md={3}>
                  <Form.Group className="mb-3" controlId="">
                    <Form.Label>
                      Do you have Tamper Evident Bags? {"  "}
                    </Form.Label>
                    <div className="mt-2 start-return-option-type">
                      <Form.Check
                        disabled={tmp !== "start-Inventoried-return"}
                        inline
                        type={"radio"}
                        label={"YES"}
                        name="radioGroup"
                        defaultChecked={true}
                        checked={selectedRadio === "YES"}
                        onChange={(e) => radioChange(e, "YES")}
                      />
                      <Form.Check
                        disabled={tmp !== "start-Inventoried-return"}
                        inline
                        type={"radio"}
                        label={"NO"}
                        name="radioGroup"
                        checked={selectedRadio === "NO"}
                        onChange={(e) => radioChange(e, "NO")}
                      />
                      <Form.Check
                        disabled={tmp !== "start-Inventoried-return"}
                        inline
                        type={"radio"}
                        label={"No Controls"}
                        name="radioGroup"
                        checked={selectedRadio === "No Controls"}
                        onChange={(e) => radioChange(e, "No Controls")}
                      />
                    </div>
                  </Form.Group>
                </Col>
                {["YES", "No Controls"].includes(selectedRadio) && (
                  <Col xs={6} md={3}>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Supply type {"  "}</Form.Label>
                      <div className="mt-2 start-return-option-type">
                        <Form.Check
                          inline
                          disabled={tmp !== "start-Inventoried-return"}
                          type={"radio"}
                          label={"BNS Kit"}
                          name="radioGroupST"
                          defaultChecked={true}
                          checked={supplyTypeRadio === "BNS Kit"}
                          value="BNS Kit"
                          onChange={(e) => radioChangeSupplyType(e, "BNS Kit")}
                        />
                        <Form.Check
                          inline
                          checked={supplyTypeRadio === "Print Labels"}
                          value="Print Labels"
                          disabled={tmp !== "start-Inventoried-return"}
                          type={"radio"}
                          label={"Print Labels"}
                          name="radioGroupST"
                          onChange={(e) =>
                            radioChangeSupplyType(e, "Print Labels")
                          }
                        />
                        <Form.Check
                          inline
                          checked={supplyTypeRadio === "Use Pre-printed labels"}
                          value="Use Pre-printed labels"
                          disabled={tmp !== "start-Inventoried-return"}
                          type={"radio"}
                          label={"Use Pre-printed labels"}
                          name="radioGroupST"
                          onChange={(e) =>
                            radioChangeSupplyType(e, "Use Pre-printed labels")
                          }
                          onClick={(e) =>
                            radioChangeSupplyType(e, "Use Pre-printed labels")
                          }
                        />
                        {errorUsePreprintedLabels && (
                          <p className="error-validation">{errorUsePreprintedLabels}</p>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </>
            )}
            {(entryMode === "1" || entryMode === "2" || entryMode === "3") && (
              <Col lg={6} xs={12}>
                <Row className={`gx-3 three `}>
                  <Col xs={12} md={6} xl={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Qty. of shipping labels{" "}
                        {entryMode === "3" ||
                          (entryMode === "1" && supplyTypeRadio === "Print Labels") ||
                          (entryMode === "1" && supplyTypeRadio === "Use Pre-printed labels") ? (
                          <></>
                        ) : (
                          <i className="fa fa-asterisk  error-estric"></i>
                        )}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Limit of 10"
                        onChange={(e) => {
                          setShippingLabelQuantity(e.target.value);
                          setErrorShippingLable("");
                          if (Number(e.target.value) > 10) {

                            setErrorShippingLable(
                              "Quantity of Shipping Labels Value should not be greater than 10"
                            );
                          } else if (e.target.value?.includes(".")) {
                            setErrorShippingLable(
                              "Invalid value"
                            );
                          } else if (Number(e.target.value) < 0.01) {
                            setErrorShippingLable(
                              "Quantity must be greater than 0"
                            );
                          }

                          else {
                            setShippingLabelQuantity(e.target.value);
                          }
                        }}
                        min="1"
                        max="10"
                        value={shippingLabelQuantity}
                        disabled={isInputDisabled}
                        onKeyDown={(evt) => {
                          if (
                            evt.key === "e" ||
                            evt.key === "ArrowUp" ||
                            evt.key === "ArrowDown"
                          ) {
                            evt.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.currentTarget.blur()}
                      />
                      {errorShippingLable && (
                        <p className="error-validation">{errorShippingLable}</p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={6} md={3} xl={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Qty. of tamper-evident bags{" "}
                        {entryMode === "3" ||
                          (entryMode === "1" &&
                            supplyTypeRadio === "Print Labels") || (entryMode === "1" && supplyTypeRadio === "Use Pre-printed labels") ? (
                          <></>
                        ) : (
                          <i className="fa fa-asterisk  error-estric"></i>
                        )}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Limit of 20"
                        onChange={(e) => {
                          setTamperEvidentBagQuantity(e.target.value);
                          setErrorTamperBag("");

                          if (Number(e.target.value) > 20) {
                            setErrorTamperBag(
                              "Quantity of Tamper Evident Value should not be greater than 20"
                            );
                          }
                          else if (e.target.value?.includes(".")) {
                            setErrorTamperBag(
                              "Invalid value"
                            );
                          } else if (Number(e.target.value) < 0.01) {
                            setErrorTamperBag(
                              "Quantity must be greater than 0"
                            );
                          }
                          else {

                            setErrorTamperBag("");

                          }
                        }}
                        min="1"
                        onWheel={(e) => e.currentTarget.blur()}
                        max="20"
                        value={tamperEvidentBagQuantity}
                        disabled={isInputDisabled}
                        onKeyDown={(evt) => {
                          if (
                            evt.key === "e" ||
                            evt.key === "ArrowUp" ||
                            evt.key === "ArrowDown"
                          ) {
                            evt.preventDefault();
                          }
                        }}
                      />
                      {errorTamperBag && (
                        <p className="error-validation">{errorTamperBag}</p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            )}
            {entryMode === "4" && (
              <Col xs={6} md={3} xl={3}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Sales order{" "}
                    <i className="fa fa-asterisk  error-estric"></i>
                  </Form.Label>
                  {onsiteInventoryAssociationSO_options && (
                    <Select
                      value={
                        onsiteInventoryAssociationSOID
                          ? {
                            value: onsiteInventoryAssociationSOID,
                            label: onsiteInventoryAssociationSOTranId,
                          }
                          : {}
                      }
                      required
                      options={onsiteInventoryAssociationSO_options}
                      onChange={(option) => onsiteInventoryAssociationSOChange(option)}
                      isClearable
                      isDisabled={
                        tmp !== "start-Inventoried-return"
                          ? true
                          : false
                      }

                    />
                  )}
                  {errorOnsiteInventoryAssociationSOMessage && (
                    <p className="error-validation">{errorOnsiteInventoryAssociationSOMessage}</p>
                  )}
                </Form.Group>
              </Col>
            )}

          </Row>
        </Form>
      </div>
      {props.StatusMode === "Draft" ||
        props.link === "start-Inventoried-return" ? (
        <div className="four">
          {" "}
          <Form className="form_box form_box_bg form_box_full pb-0 mb-2">
            <Row>
              <Col xs={12} xl={6}>
                <Row className="justify-content-start">
                  <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        NDC <i className="fa fa-asterisk  error-estric"></i>
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        id="ndc"
                        autoFocus
                        placeholder=""
                        type="number"
                        maxLength={10}
                        onKeyDown={onKeyDownHandler}
                        onKeyUp={onKeyUpHandler}
                        onChange={(e) => {
                          setErrorNDCMessage("");
                          setNdcValue(e.target.value);
                        }}
                        onBlur={(e) => NdcValueBlur(e)}
                        min="0"
                        value={ndcValue}
                        onPaste={onNDCPaste}
                        onWheel={(e) => e.currentTarget.blur()}
                        disabled={bnsAccountId === "" ? true : false}
                      />
                      {errorNDCMessage && (
                        <p className="error-validation">{errorNDCMessage}</p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Full Quantity{" "}
                        <i className="fa fa-asterisk  error-estric"></i>
                      </Form.Label>
                      <div className="quantityContainer">
                        <Form.Control
                          type="number"
                          size="sm"
                          placeholder=""
                          disabled={bnsAccountId === "" ? true : !quantity ? false : true}
                          onKeyDown={(e: any) => {
                            if (
                              e.key === "e" ||
                              e.key === "ArrowUp" ||
                              e.key === "ArrowDown" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }

                            if (
                              (e.keyCode === 9 && quantityData === "") ||
                              quantityData === "0"
                            ) {
                              setQuantity(true);
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value.includes(".")) {
                              setErrorQuantityMessage(
                                "Quantity must be a whole number."
                              );
                            } else if (Number(e.target.value) <= 0) {
                              setErrorQuantityMessage(
                                "Quantity must be greater than 0."
                              );
                            } else if (Number(e.target.value) > 9999) {
                              setErrorQuantityMessage(
                                "Quantity allows maximum 4 digit."
                              );
                            } else {
                              setErrorQuantityMessage("");
                            }

                            setNdcDetailsDataQuantityValidation(
                              e.target.value,
                              quantity
                            );
                          }}
                          min="1"
                          value={!quantity ? quantityData : ""}
                          onWheel={(e) => e.currentTarget.blur()}

                        />
                      </div>
                      {!quantity ? (
                        <>
                          {errorQuantityMessage && (
                            <p className="error-validation">
                              {errorQuantityMessage}
                            </p>
                          )}
                          {quantityGreaterMessage && (
                            <p className="error-validation">
                              {quantityGreaterMessage}
                            </p>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Partial Quantity{" "}
                        <i className="fa fa-asterisk  error-estric"></i>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        size="sm"
                        placeholder=""
                        disabled={bnsAccountId === "" ? true : quantity ? false : true}
                        onKeyDown={(evt) => {
                          if (
                            evt.key === "e" ||
                            evt.key === "ArrowUp" ||
                            evt.key === "ArrowDown" ||
                            evt.key === "-" ||
                            evt.key === "+"
                          ) {
                            evt.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          if (
                            e.target.value !== "" &&
                            e.target.value !== null &&
                            e.target.value !== undefined
                          ) {
                            setNdcDetailsDataQuantityValidation(
                              e.target.value,
                              quantity
                            );
                            if (
                              e.target.value.includes(".") &&
                              ndcDetailsData?.casePack > 1
                            ) {
                              setErrorQuantityMessage(
                                "Quantity must be a whole number."
                              );
                            } else if (
                              ndcDetailsData?.casePack > 1 &&
                              parseFloat(e.target.value) >
                              ndcDetailsData?.casePack
                            ) {
                              setErrorQuantityMessage(
                                "Partial Quantity cannot be greater than case pack."
                              );
                            } else if (
                              ndcDetailsData?.casePack === 1 &&
                              parseFloat(e.target.value) >
                              ndcDetailsData?.packageSize
                            ) {
                              setErrorQuantityMessage(
                                "Partial Quantity cannot be greater than package size."
                              );
                            } else if (
                              parseFloat(e.target.value) <= parseInt(packageSize)
                            ) {
                              if (Number(e.target.value) <= 0) {
                                setErrorQuantityMessage(
                                  "Quantity must be greater than 0."
                                );
                              } else if (Number(e.target.value) > 9999) {
                                setErrorQuantityMessage(
                                  "Quantity allows maximum 4 digit."
                                );
                              } else {
                                setErrorQuantityMessage("");
                              }
                            } else if (
                              e.target.value !== "" ||
                              e.target.value !== null
                            ) {
                              setErrorQuantityMessage("");
                            }
                          } else {
                            setErrorQuantityMessage("");

                            setNdcDetailsDataQuantityValidation("", "");
                          }
                        }}
                        value={quantity ? quantityData : ""}
                        min="1"
                        onWheel={(e) => e.currentTarget.blur()}
                      />
                      {quantity ? (
                        <>
                          {errorQuantityMessage && (
                            <p className="error-validation">
                              {errorQuantityMessage}
                            </p>
                          )}
                          {quantityGreaterMessage && (
                            <p className="error-validation">
                              {quantityGreaterMessage}
                            </p>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>LOT#</Form.Label>
                      <Form.Control
                        disabled={entryMode === "" ? true : false}
                        size="sm"
                        placeholder=""
                        value={lotNumber}
                        onChange={(e) => {
                          const input = e.target.value;
                          const regex = /^[ A-Za-z0-9.-]*$/;
                          if (regex.test(input)) {
                            setLotNumber(input);
                            setErrorLotMessage("");
                          } else {
                            setErrorLotMessage("Special characters are not allowed.");
                          }
                        }}
                        min="0"
                      />
                      {errorLotMessage && (
                        <p className="error-validation">{errorLotMessage}</p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Col>

              <Col xs={12} xl={6}>
                <Row className="justify-content-start">
                  <Col xs={12} md={3}>
                    <Form.Group className="mb-3 custom-date-range">
                      <Form.Label>Expiration Date</Form.Label>
                      <DatePicker
                        id="expiration-date"
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        disabled={entryMode === ""}
                        toggleCalendarOnIconClick
                        closeOnScroll={true}
                        selected={entryMode === "" ? null : selectedDate}
                        onChange={(date: any) => {
                         setErrorDateMessage("");
                          setSelectedDate(date);
                        }}
                        onChangeRaw={(event: any) => {
                          handleChangeRaw(event.target.value)
                        }}
                        placeholderText="MM/YYYY"
                        className="form-control"
                        minDate={minDate}
                        maxDate={maxDate}
                      />                      
                      {errorDateMessage && (
                        <p className="error-validation">{errorDateMessage}</p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>GS1 Serial# </Form.Label>
                      <Form.Control
                        disabled={entryMode === "" ? true : false}
                        type="text"
                        size="sm"
                        placeholder=""
                        id="gs1serial"
                        value={gs1SerialNumber}
                        onChange={(e) => setGs1SerialNumber(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3} xl="auto">
                    <Form.Group className="mb-3">
                      <Form.Label>FULL/PARTIAL</Form.Label>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        label=""
                        onChange={(e) => switchChange(e)}
                        checked={quantity}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label className="d-block">&nbsp;</Form.Label>
                      <Button
                        variant="primary"
                        size="sm"
                        className="px-4"
                        onClick={(e) => addButtonClick(e)}
                        disabled={
                          !DEALicence ||
                            errorQuantityMessage !== "" ||
                            bnsAccountId === "" ||
                            bnsAccountName === "" ||
                            entryMode === "" ||
                            upsNoGround === true
                            ? true
                            : false
                        }
                      >
                        <i className="fa-solid fa-plus me-1"></i>Add
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>

              {ndcUnavailableError ? (
                <Col xs={12}>
                  <div className="text-danger form-text font-12 mb-3">
                    Entered NDC number is not valid or unavailable, please{" "}
                    <Link
                      to="#"
                      className="text-danger fw-bold"
                      onClick={() => setShow(true)}
                    >
                      click here
                    </Link>{" "}
                    to submit request to our customer support team
                  </div>
                </Col>
              ) : (
                <></>
              )}
              <NdcDetailsModal
                detailModalShow={show}
                handleClose={handleClose}
                handleSave={handleSave}
                errorMessage={bnsSelectionError}
              ></NdcDetailsModal>
              {showNDCDetailsContainer &&
                ndcDetailsData &&
                Object?.keys(ndcDetailsData).length !== 0 ? (
                <NDCDetails
                  ndcDetailsData={ndcDetailsData}
                  quantityData={quantityData}
                  quantity={quantity}
                ></NDCDetails>
              ) : (
                <></>
              )}
              <NewNdcSuccessModal
                show={ndSuccessShow}
                handleClose={ndcSucessClose}
                message1={"Your request has been submitted successfully."}
                message2={"Our customer support team will reach out to you shortly."}
                message3={isCustomNDCMessage && "You can add this product to the return."}
              ></NewNdcSuccessModal>
            </Row>
          </Form>
        </div>
      ) : (
        <></>
      )}

      <PrePrintedLabelsSubmittedModal
        show={isPrePrintedLabelsSubmittedModal}
        handleClose={handleClosePrePrintedSubmittedLabels}
        orderid={orderid}
      ></PrePrintedLabelsSubmittedModal>

      <DotInventoryModal
          show={dotInventoryShow}
          handleClose={dotInventoryClose}
          message={dotInventoryMessage}
          icon={dotInventoryIcon}
      ></DotInventoryModal>

      <PrePrintedLabelsModal
        accountid={bnsAccountId}
        show={isPrePrintedLabelsModal}
        handleClose={handleClosePrePrintedLabels}
        onError={handlerePrintedLabelsError}
      ></PrePrintedLabelsModal>
    </>
  );
});

export default StartReturnHeader;